import { render, staticRenderFns } from "./citizenReport.vue?vue&type=template&id=aa807344"
import script from "./citizenReport.vue?vue&type=script&lang=js"
export * from "./citizenReport.vue?vue&type=script&lang=js"
import style0 from "./citizenReport.vue?vue&type=style&index=0&id=aa807344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports